var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inertia-link',{attrs:{"href":_vm.route('contract.show', {'contract': _vm.contract.id})}},[_vm._v("\n  "+_vm._s(_vm.contract.number)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }